import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetGoalsByStage as GetGoalsByStageQuery,
    GetGoalsByStageVariables,
    LeadGoalFragment as GoalFragment,
} from 'nutshell-graphql-types';

import GET_GOALS_BY_STAGE from '../queries/get-goals-by-stage.graphql';

export const useGetGoalsByStage = (
    leadId: string,
    shouldSkip: boolean
): {
    goalsByStage: GoalFragment[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetGoalsByStageQuery,
        GetGoalsByStageVariables
    >(GET_GOALS_BY_STAGE, {
        variables: {
            leadId,
        },
        skip: shouldSkip,
    });

    const goalsByStage = data && data.lead && data.lead.stages && data.lead.stages.edges;

    return {
        goalsByStage: goalsByStage || [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
